var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSessionTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0a5 5 0 110 10A5 5 0 015 0zm0 1.4a.6.6 0 00-.6.6v3l.007.094a.6.6 0 00.169.33l2 2 .083.07a.6.6 0 00.765-.07l.07-.083a.6.6 0 00-.07-.765L5.6 4.75V2l-.008-.097A.6.6 0 005 1.4z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSessionTime);
export default __webpack_public_path__ + "static/media/ic_session_time.2eca1829.svg";
export { ForwardRef as ReactComponent };